<template>
  <div class="c-led-pcb-75" v-visible="!loading">
    <img class="background" :src="images.led_in_switch_75" @load="onLoad" />
    <div class="leds">
      <div
        v-for="LED in LEDs"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft({ color: frameRGB[LED.index], index: LED.index })
        "
        @mousedown.right="
          onMouseDownRight({ color: frameRGB[LED.index], index: LED.index })
        "
        @mouseenter="
          onMouseEnter({ color: frameRGB[LED.index], index: LED.index }, $event)
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: frameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: frameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') + frameRGB[LED.index],
              opacity: 1 || getLight(frameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="spotlights">
      <div
        v-for="LED in spotlights"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft(
            {
              color: spotlightFrameRGB[LED.index],
              index: LED.index,
            },
            true
          )
        "
        @mousedown.right="
          onMouseDownRight(
            {
              color: spotlightFrameRGB[LED.index],
              index: LED.index,
            },
            true
          )
        "
        @mouseenter="
          onMouseEnter(
            { color: spotlightFrameRGB[LED.index], index: LED.index },
            $event,
            true
          )
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: spotlightFrameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: spotlightFrameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') +
                spotlightFrameRGB[LED.index],
              opacity: 1 || getLight(spotlightFrameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";

export default {
  name: "CLedPcb75",
  props: {
    isPlaying: Boolean,
    speed: Number,
    frames: Array,
    spotlightFrames: Array,
    frameIndex: Number,
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
      LEDs: [
        { index: 0, style: { top: "0%", left: "0%" } },
        { index: 1, style: { top: "0%", left: "8.1%" } },
        { index: 2, style: { top: "0%", left: "14.4%" } },
        { index: 3, style: { top: "0%", left: "20.9%" } },
        { index: 4, style: { top: "0%", left: "27.3%" } },
        { index: 5, style: { top: "0%", left: "35.3%" } },
        { index: 6, style: { top: "0%", left: "41.7%" } },
        { index: 7, style: { top: "0%", left: "48.1%" } },
        { index: 8, style: { top: "0%", left: "54.5%" } },
        { index: 9, style: { top: "0%", left: "62.5%" } },
        { index: 10, style: { top: "0%", left: "68.9%" } },
        { index: 11, style: { top: "0%", left: "75.3%" } },
        { index: 12, style: { top: "0%", left: "81.7%" } },
        { index: 13, style: { top: "0%", left: "89.6%" } },
        { index: 14, style: { top: "0%", left: "96%" } },

        { index: 15, style: { top: "21%", left: "0%" } },
        { index: 16, style: { top: "21%", left: "6.4%" } },
        { index: 17, style: { top: "21%", left: "12.8%" } },
        { index: 18, style: { top: "21%", left: "19.2%" } },
        { index: 19, style: { top: "21%", left: "25.6%" } },
        { index: 20, style: { top: "21%", left: "32.1%" } },
        { index: 21, style: { top: "21%", left: "38.4%" } },
        { index: 22, style: { top: "21%", left: "44.8%" } },
        { index: 23, style: { top: "21%", left: "51.1%" } },
        { index: 24, style: { top: "21%", left: "57.6%" } },
        { index: 25, style: { top: "21%", left: "64%" } },
        { index: 26, style: { top: "21%", left: "70.4%" } },
        { index: 27, style: { top: "21%", left: "76.8%" } },
        {
          index: 28,
          style: { width: "10%", top: "21%", left: "82.9%", paddingLeft: "2%" },
        },
        { index: 29, style: { top: "21%", left: "96%" } },

        {
          index: 30,
          style: { width: "7%", top: "37.3%", left: "0%", paddingLeft: "0.5%" },
        },
        { index: 31, style: { top: "37.3%", left: "9.7%" } },
        { index: 32, style: { top: "37.3%", left: "16%" } },
        { index: 33, style: { top: "37.3%", left: "22.4%" } },
        { index: 34, style: { top: "37.3%", left: "28.9%" } },
        { index: 35, style: { top: "37.3%", left: "35.3%" } },
        { index: 36, style: { top: "37.3%", left: "41.6%" } },
        { index: 37, style: { top: "37.3%", left: "48%" } },
        { index: 38, style: { top: "37.3%", left: "54.4%" } },
        { index: 39, style: { top: "37.3%", left: "60.8%" } },
        { index: 40, style: { top: "37.3%", left: "67.2%" } },
        { index: 41, style: { top: "37.3%", left: "73.6%" } },
        { index: 42, style: { top: "37.3%", left: "80%" } },
        { index: 43, style: { width: "7%", top: "37.3%", left: "86.9%" } },
        { index: 44, style: { top: "37.3%", left: "96%" } },

        {
          index: 45,
          style: { width: "8.8%", top: "54%", left: "0%", paddingLeft: "0.5%" },
        },
        { index: 46, style: { top: "54%", left: "11.3%" } },
        { index: 47, style: { top: "54%", left: "17.7%" } },
        { index: 48, style: { top: "54%", left: "24.1%" } },
        { index: 49, style: { top: "54%", left: "30.4%" } },
        { index: 50, style: { top: "54%", left: "36.8%" } },
        { index: 51, style: { top: "54%", left: "43.1%" } },
        { index: 52, style: { top: "54%", left: "49.5%" } },
        { index: 53, style: { top: "54%", left: "55.9%" } },
        { index: 54, style: { top: "54%", left: "62.2%" } },
        { index: 55, style: { top: "54%", left: "68.6%" } },
        { index: 56, style: { top: "54%", left: "75.1%" } },
        {
          index: 58,
          style: { width: "12%", top: "54%", left: "80.5%", paddingLeft: "3%" },
        },
        { index: 59, style: { top: "54%", left: "96%" } },

        {
          index: 60,
          style: { width: "12%", top: "71%", left: "0%", paddingLeft: "2.8%" },
        },
        { index: 62, style: { top: "71%", left: "14.6%" } },
        { index: 63, style: { top: "71%", left: "20.9%" } },
        { index: 64, style: { top: "71%", left: "27.3%" } },
        { index: 65, style: { top: "71%", left: "33.7%" } },
        { index: 66, style: { top: "71%", left: "40%" } },
        { index: 67, style: { top: "71%", left: "46.4%" } },
        { index: 68, style: { top: "71%", left: "52.7%" } },
        { index: 69, style: { top: "71%", left: "59.1%" } },
        { index: 70, style: { top: "71%", left: "65.5%" } },
        { index: 71, style: { top: "71%", left: "71.9%" } },
        {
          index: 72,
          style: {
            width: "8.8%",
            top: "71%",
            left: "77.3%",
            paddingLeft: "2.8%",
          },
        },
        { index: 73, style: { top: "71%", left: "89.6%" } },

        {
          index: 75,
          style: {
            width: "5.7%",
            top: "87.5%",
            left: "0%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 76,
          style: {
            width: "5.7%",
            top: "87.5%",
            left: "8.1%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 77,
          style: {
            width: "5.7%",
            top: "87.5%",
            left: "16.1%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 79,
          style: { top: "87.5%", left: "24.2%" },
        },
        {
          index: 80,
          style: { top: "87.5%", left: "40.7%" },
        },
        {
          index: 81,
          style: { top: "87.5%", left: "57.7%" },
        },
        {
          index: 85,
          style: {
            width: "5.7%",
            top: "87.5%",
            left: "64%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 86,
          style: {
            width: "5.7%",
            top: "87.5%",
            left: "72%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 87,
          style: { top: "87.5%", left: "83.2%" },
        },
        {
          index: 88,
          style: { top: "87.5%", left: "89.5%" },
        },
        { index: 89, style: { top: "87.5%", left: "96%" } },
      ],
      spotlights: [
        {
          index: 0,
          style: { top: "0", left: "0%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 1,
          style: { top: "0", left: "4%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 2,
          style: { top: "0", left: "8%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 3,
          style: { top: "0", left: "12%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 4,
          style: { top: "0", left: "84%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 5,
          style: { top: "0", left: "88%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 6,
          style: { top: "0", left: "92%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 7,
          style: { top: "0", left: "96%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
      ],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frame_RGB : [];
      }
      return [];
    },
    spotlightFrameRGB() {
      if (this.spotlightFrames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.spotlightFrames[index]
          ? this.spotlightFrames[index].frame_RGB
          : [];
      }
      return [];
    },
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    getLight(hex) {
      const regs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(regs[1], 16);
      let g = parseInt(regs[2], 16);
      let b = parseInt(regs[3], 16);

      (r /= 255), (g /= 255), (b /= 255);

      const max = Math.max(r, g, b);
      const light = max * 2;
      return light.toFixed(3);
    },
    play() {
      console.log(this.spotlightFrames);
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        const speed = speedList[this.speed - 1] - 2;
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, speed);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }, isSpotlight) {
      this.$emit(isSpotlight ? "spotlight-click" : "led-click", {
        color,
        index,
      });
    },
    onMouseDownRight({ index }, isSpotlight) {
      this.$emit(isSpotlight ? "spotlight-click-right" : "led-click-right", {
        index,
      });
    },
    onMouseEnter({ color, index }, { which, buttons }, isSpotlight) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit(isSpotlight ? "spotlight-click" : "led-click", {
          color,
          index,
        });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit(isSpotlight ? "spotlight-click-right" : "led-click-right", {
          index,
          solid: true,
        });
      }
    },
  },
  mounted() {
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-pcb-75 {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds,
  .spotlights {
    width: 82.6%;
    height: 63%;
    position: absolute;
    left: 8.4%;
    top: 24.4%;

    .led {
      width: 4.8%;
      height: 12%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;

      &:hover .content .background {
        // display: block;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          display: none;
        }

        .center {
          width: 12px;
          height: 12px;
          left: 50%;
          top: 50%;
          margin-top: -6px;
          margin-left: -6px;
          border-radius: 12px;
          position: absolute;
          filter: brightness(120%);
        }
      }
    }
  }

  .spotlights {
    height: 10%;
    top: 100%;

    .led {
      height: 100%;
      width: 100%;

      .content {
        .center {
          width: 20px;
          height: 20px;
          margin-top: -10px;
          margin-left: -10px;
        }
      }
    }
  }
}
</style>
